import type { ReactNode } from 'react';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DirectoryOccurrenceFeed } from './DirectoryOccurrenceFeed';
import { useVehicleOccurrences } from './hooks';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { AppRoutes } from '@/constants/routes';
import type { FeedEmptyStateProps } from './components';

interface VehicleEventFeedProps {
    vehicleId: string;
    titleContent?: ReactNode;
    emptyState?: FeedEmptyStateProps;
}

export function VehicleEventFeed({
    vehicleId,
    titleContent,
    emptyState,
}: VehicleEventFeedProps) {
    const { t } = useTranslation(I18nNamespace.DIRECTORY);
    const navigate = useNavigate();
    const {
        data: occurrences,
        isLoading,
        isLoadingMore,
        hasMore,
        loadMore,
    } = useVehicleOccurrences({
        vehicleId,
        pageSize: 20,
    });
    const handleViewAll = useCallback(() => {
        navigate(`${AppRoutes.EVENTS}?vehicleId=${vehicleId}`);
    }, [navigate, vehicleId]);

    return (
        <DirectoryOccurrenceFeed
            occurrences={occurrences}
            isLoading={isLoading}
            containerTitle={t('vehiclePage.vehicleEvents')}
            navigationFrom="vehicle-events"
            feedContext={{ type: 'vehicle', vehicleId }}
            onViewAll={handleViewAll}
            titleContent={titleContent}
            emptyState={emptyState}
            pagination={{ hasMore, isLoadingMore, onLoadMore: loadMore }}
        />
    );
}
